import React, { useEffect, useState } from "react";
import { MdDeleteOutline } from "react-icons/md";
import { BiPlus } from "react-icons/bi";
import { axios } from "../../../../../../../../../Global";
import {
  setAppError,
  setBreadCrumb,
} from "../../../../../../../../../store/userSlice";
import { useDispatch } from "react-redux";
import LoadingWithLable from "../../../../../../../../../ReusableComponents/Loading/LoadingWithLable";
import { useNavigate, useOutletContext } from "react-router-dom";
import CostPlusCreate from "./CostPlusCreate/CostPlusCreate";

export default function CostSheetCreate({
  quotationDetails,
  defaultRows,
  setData,
  setRowEdited,
  vBenefit,
  vBenefitValue,
}) {
  // console.log(defaultRows, "default rows");
  const [JobEnquiryInputValue] = useOutletContext();
  const [deletedArrayList, SetDeletedArrayList] = useState([]);
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [allRows, setAllRows] = useState([]);
  const [costSheetDefault, setCostSheetDefault] =
    useState(JobEnquiryInputValue);

  const [employeeSalaryPackageCols, setEmployeeSalaryPackageCols] = useState(
    []
  );
  const [govermentFeesCols, setGovermentFeesCols] = useState([]);
  const [soundLineFeesCols, setSoundLineFeesCols] = useState([]);

  useEffect(() => {
    setAllRows(defaultRows);
    setCostSheetDefault(JobEnquiryInputValue);
    setEmployeeSalaryPackageCols(defaultRows[0]?.sections[0]?.columns);
  }, [defaultRows]);

  const costDivide = (cost, value) => {
    if (cost == 0) return +cost;
    return Number(+cost / +value).toFixed(2);
  };

  const [costSheetDataLoading, setCostSheetDataLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  const [selectDatas, setSelectDatas] = useState();
  const tableHeading = [
    {
      rate_category_id: 1,
      title: "EMPLOYEE SALARY PACKAGE",
      bgPrimary: "bg-orange-400",
      bgSecondary: "bg-orange-200",
    },
    {
      rate_category_id: 2,
      title: "GOVERNMENT FEES (PER MONTH)",
      bgPrimary: "bg-cyan-700",
      bgSecondary: "bg-cyan-200",
    },
    {
      rate_category_id: 3,
      title: "SOUNDLINE FEES (ACTUALS & PER MONTH)",
      bgPrimary: "bg-green-800",
      bgSecondary: "bg-green-200",
    },
  ];

  const tableProperties = {
    colWidth: "w-56",
    colHeight: "h-[2rem]",
    itemHeight: "h-[3rem]",
  };

  useEffect(() => {
    setAllRows((rows) => {
      const updatedRows = rows?.map((row) => {
        const updatedSections = row?.sections?.map((section) => {
          const updatedColumns = section.columns?.map((column) => {
            if (vBenefit == "YES") {
              if (column?.rate_category_item_name == "VBenefit (SAR)") {
                return { ...column, disabled: false, cost: vBenefitValue || 0 };
              }
              return column;
            } else {
              if (column?.rate_category_item_name == "VBenefit (SAR)") {
                return { ...column, disabled: true, cost: 0 };
              }
              return column;
            }
          });
          return { ...section, columns: updatedColumns };
        });
        return { ...row, sections: updatedSections };
      });
      return updatedRows;
    });
  }, [vBenefit, vBenefitValue]);

  const handleCreateColumn = (rate_category_id = 1) => {
    let newObj = {
      id: Math.floor(Math.random() * 1000),
      rate_category_id: rate_category_id,
      rate_category_item_name: "",
      type: "Dynamic",
      cost: 0,
      title: "",
      default: false,
    };
    if (rate_category_id == 1)
      setEmployeeSalaryPackageCols((prev) => [...prev, newObj]);
    if (rate_category_id == 2)
      setGovermentFeesCols((prev) => [...prev, newObj]);
    if (rate_category_id == 3)
      setSoundLineFeesCols((prev) => [...prev, newObj]);

    const updatedRows = allRows.map((row) => {
      const section = row.sections.find(
        (s) => s.rate_category_id === rate_category_id
      );

      if (section) {
        return {
          ...row,
          sections: row.sections.map((s) =>
            s.rate_category_id === rate_category_id
              ? { ...s, columns: [...s.columns, newObj] }
              : s
          ),
        };
      }

      return row;
    });

    // Update the state with the modified array
    setAllRows(updatedRows);
  };

  const handleDeleteColumn = (sectionId, columnId) => {
    const updatedRows = allRows.map((row) => {
      const updatedSections = row.sections.map((section) => {
        if (section.rate_category_id == sectionId) {
          const updatedColumns = section.columns.filter(
            (column) => column.id !== columnId
          );
          return {
            ...section,
            columns: updatedColumns,
          };
        }
        return section;
      });

      return {
        ...row,
        sections: updatedSections,
      };
    });

    setAllRows(updatedRows);
    if (sectionId == 1) {
      setEmployeeSalaryPackageCols((prev) =>
        prev.filter((column) => column.id != columnId)
      );
    }
    if (sectionId == 2) {
      setGovermentFeesCols((prev) =>
        prev.filter((column) => column.id != columnId)
      );
    }
    if (sectionId == 3) {
      setSoundLineFeesCols((prev) =>
        prev.filter((column) => column.id != columnId)
      );
    }
  };

  console.log(vBenefitValue, "benefit value");

  const handleCreateRow = () => {
    setRowEdited(true);
    setAllRows((prev) => [
      ...prev,
      {
        type: "new",
        id: Math.floor(Math.random() * 1000),
        job_position_id: "",
        visa_profession_id: "",
        profession_level_id: "",
        gender: "",
        nationality_id: "",
        quantity: "",
        sections: [
          {
            rate_category_id: 1,
            columns: employeeSalaryPackageCols.map((column) => {
              if (column.rate_category_item_name == "VBenefit (SAR)") {
                return { ...column, cost: vBenefitValue || 0 };
              }
              return column;
            }),
          },
          // {
          //   rate_category_id: 2,
          //   columns: govermentFeesCols,
          // },
          // {
          //   rate_category_id: 3,
          //   columns: soundLineFeesCols,
          // },
        ],
      },
    ]);
  };

  const handleDeleteRow = (rowId) => {
    setRowEdited(true);
    allRows.forEach((item) => {
      if (item.id == rowId) {
        if (item.type !== "new") {
          SetDeletedArrayList((prev) => [
            ...prev,
            {
              project_job_enquiry_cost_sheet_profession_basic_information_id:
                rowId,
            },
          ]);
        }
      }
    });
    setAllRows((prev) => {
      const updatedData = prev.filter((prevData) => prevData.id != rowId);
      if (updatedData.length != 0) {
        return updatedData;
      } else {
        return prev;
      }
    });
  };

  const handleUpdateColumn = (
    rowId,
    rate_category_id,
    columnId,
    updatedKey,
    updatedValue,
    columnName
  ) => {
    setRowEdited(true);
    const updatedRows = allRows.map((row) => {
      let currentValueOfHRA = 0;
      let currentValueOfBasic = 0;
      if (updatedKey == "cost") {
        if (row.id == rowId) {
          const updatedSections = row.sections.map((section) => {
            if (section.rate_category_id == 1) {
              currentValueOfHRA = Number(
                section.columns.find(
                  (column) => column?.rate_category_item_name == "HRA"
                )?.cost
              );
            }
            if (section.rate_category_id == 1) {
              currentValueOfBasic = Number(
                section.columns.find(
                  (column) => column?.rate_category_item_name == "BASIC"
                )?.cost
              );
            }

            if (section.rate_category_id == rate_category_id) {
              const updatedColumns = section.columns.map((column) => {
                if (column.id == columnId) {
                  return {
                    ...column,
                    [updatedKey]: updatedValue,
                  };
                }
                return column;
              });
              return { ...section, columns: updatedColumns };
            }

            if (columnName == "BASIC" && section.rate_category_id == 3) {
              const updatedGosi = section.columns.map((column) => {
                if (column.rate_category_item_name == "GOSI") {
                  return {
                    ...column,
                    cost: Number(
                      ((Number(updatedValue) + Number(currentValueOfHRA)) * 2) /
                        100
                    ).toFixed(2),
                  };
                }
                return column;
              });
              return { ...section, columns: updatedGosi };
            }

            if (columnName == "BASIC" && section.rate_category_id == 2) {
              const updatedCostByEquation = section.columns.map((column) => {
                if (column?.rate_category_item_name == "END OF SERVICE") {
                  return {
                    ...column,
                    cost: Number(
                      (Number(updatedValue) / 30) * (15 / 12)
                    ).toFixed(2),
                  };
                } else if (
                  column?.rate_category_item_name == "VACATION SALARY"
                ) {
                  return {
                    ...column,
                    cost: Number(
                      (Number(updatedValue) / 30) * (21 / 12)
                    ).toFixed(2),
                  };
                }
                return column;
              });
              return { ...section, columns: updatedCostByEquation };
            }

            if (columnName == "HRA" && section.rate_category_id == 3) {
              const updatedGosi = section.columns.map((column) => {
                if (column.rate_category_item_name == "GOSI") {
                  return {
                    ...column,
                    cost: Number(
                      ((Number(updatedValue) + Number(currentValueOfBasic)) *
                        2) /
                        100
                    ).toFixed(2),
                  };
                }
                return column;
              });
              return { ...section, columns: updatedGosi };
            }
            return section;
          });
          return { ...row, sections: updatedSections };
        }
        return row;
      } else {
        if (updatedKey == "rate_category_item_name") {
          if (rate_category_id == 1) {
            setEmployeeSalaryPackageCols((prevState) =>
              prevState.map((state) => {
                if (state?.id == columnId) {
                  return { ...state, rate_category_item_name: updatedValue };
                }
                return state;
              })
            );
          }
          if (rate_category_id == 2) {
            setGovermentFeesCols((prevState) =>
              prevState.map((state) => {
                if (state?.id == columnId) {
                  return { ...state, rate_category_item_name: updatedValue };
                }
                return state;
              })
            );
          }
          if (rate_category_id == 3) {
            setSoundLineFeesCols((prevState) =>
              prevState.map((state) => {
                if (state?.id == columnId) {
                  return { ...state, rate_category_item_name: updatedValue };
                }
                return state;
              })
            );
          }
        }
        const updatedSections = row.sections.map((section) => {
          if (section.rate_category_id == rate_category_id) {
            const updatedColumns = section.columns.map((column) => {
              if (column.id == columnId) {
                return { ...column, [updatedKey]: updatedValue };
              }
              return column;
            });
            return { ...section, columns: updatedColumns };
          }
          return section;
        });
        return { ...row, sections: updatedSections };
      }
    });

    setAllRows(updatedRows);
  };

  const handleUpdateRowProperties = (rowId, updatingKey, updatingValue) => {
    setRowEdited(true);

    const updatedRows = allRows.map((row) => {
      if (row.id == rowId) {
        if (updatingKey == "profession_level_id") {
          const updatedSections = row.sections.map((section) => {
            if (section.rate_category_id == 3) {
              const updatedColumns = section.columns.map((column) => {
                if (column.rate_category_item_name == "NITAKAT") {
                  return {
                    ...column,
                    cost: costSheetDefault.profession_level.find(
                      (profession) => profession.id == updatingValue
                    )?.nitakat,
                  };
                }
                if (column.rate_category_item_name == "ADMIN FEE") {
                  return {
                    ...column,
                    cost: costSheetDefault.profession_level.find(
                      (profession) => profession.id == updatingValue
                    )?.admin_fee,
                  };
                }
                if (column.rate_category_item_name == "SOUNDLINE SERVICE FEE") {
                  return {
                    ...column,
                    cost: costSheetDefault.profession_level.find(
                      (profession) => profession.id == updatingValue
                    )?.soundline_fee,
                  };
                }
                return column;
              });
              return { ...section, columns: updatedColumns };
            }
            return section;
          });
          return {
            ...row,
            sections: updatedSections,
            [updatingKey]: updatingValue,
          };
        }
        return { ...row, [updatingKey]: updatingValue };
      }
      return row;
    });
    setAllRows(updatedRows);
  };

  //final data

  useEffect(() => {
    const costSheetEdited = [];
    const costSheetNew = [];
    const costSheetHeadingType = [];
    for (let i = 0; i < allRows.length; i++) {
      const costSheetHeadingContent = [];
      for (let section of allRows[i].sections) {
        for (let column of section.columns) {
          costSheetHeadingContent.push({
            project_job_enquiry_cost_sheet_heading_id: column?.id,
            cost: String(column?.cost),
          });
        }
      }
      if (allRows[i]?.type != "new") {
        costSheetEdited.push({
          ...{
            project_job_enquiry_cost_sheet_profession_basic_information_id:
              allRows[i]?.id,
            job_position_id: allRows[i].job_position_id,
            visa_profession_id: allRows[i].visa_profession_id,
            profession_level_id: allRows[i].profession_level_id,
            gender: allRows[i].gender,
            nationality_id: allRows[i].nationality_id,
            quantity: allRows[i].quantity,
          },
          cost_sheet_heading: costSheetHeadingContent,
        });
      } else {
        costSheetNew.push({
          ...{
            job_position_id: allRows[i].job_position_id,
            visa_profession_id: allRows[i].visa_profession_id,
            profession_level_id: allRows[i].profession_level_id,
            gender: allRows[i].gender,
            nationality_id: allRows[i].nationality_id,
            quantity: allRows[i].quantity,
          },
          cost_sheet_heading: costSheetHeadingContent,
        });
      }
    }
    const resultObj = {
      cost_sheet_edit: costSheetEdited,
      cost_sheet_new: costSheetNew,
    };

    setData((prev) => ({
      ...prev,
      cost_sheet_edit: costSheetEdited,
      cost_sheet_new: costSheetNew,
    }));

    // console.log(resultObj, "final payload");
  }, [allRows]);

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   setSubmitLoading(true);
  //   const costSheet = [];
  //   const costSheetHeadingType = [];
  //   for (let i = 0; i < allRows.length; i++) {
  //     const costSheetHeadingContent = [];
  //     for (let section of allRows[i].sections) {
  //       for (let column of section.columns) {
  //         costSheetHeadingContent.push({
  //           rate_category_id: column?.rate_category_id,
  //           ...(column.rate_category_item_id && {
  //             rate_category_item_id: column?.rate_category_item_id,
  //           }),
  //           ...(column.type == "Dynamic" && {
  //             rate_category_item_name: column?.rate_category_item_name,
  //           }),
  //           type: column?.type == "Dynamic" ? "Dynamic" : "Default",
  //           cost: column?.cost,
  //         });
  //         if (i == 0) {
  //           costSheetHeadingType.push({
  //             rate_category_id: column.rate_category_id,
  //             ...(column.rate_category_item_id && {
  //               rate_category_item_id: column.rate_category_item_id,
  //             }),
  //             ...(column.type == "Dynamic" && {
  //               rate_category_item_name: column.rate_category_item_name,
  //             }),
  //             type: column.type == "Dynamic" ? "Dynamic" : "Default",
  //           });
  //         }
  //       }
  //     }
  //     costSheet.push({
  //       ...{
  //         job_position_id: allRows[i].job_position_id,
  //         visa_profession_id: allRows[i].visa_profession_id,
  //         profession_level_id: allRows[i].profession_level_id,
  //         gender: allRows[i].gender,
  //         nationality_id: allRows[i].nationality_id,
  //         quantity: allRows[i].quantity,
  //       },
  //       cost_sheet_heading: costSheetHeadingContent,
  //     });
  //   }
  //   const resultObj = {
  //     cost_sheet: costSheet,
  //     cost_sheet_heading: costSheetHeadingType,
  //   };

  //   console.log(resultObj, "final payload");
  //   // return;
  //   axios
  //     .post(`/dashboard/quotation-cost-sheet-module`, resultObj, {
  //       headers: { Authorization: `Bearer ${token}` },
  //     })
  //     .then((res) => {
  //       dispatch(
  //         setAppError({
  //           msg: res?.data?.message || "Successfully created.",
  //           color: "success",
  //         })
  //       );
  //     })
  //     .catch((err) => {
  //       dispatch(
  //         setAppError({
  //           msg: err.message,
  //         })
  //       );
  //     })
  //     .finally(() => {
  //       setSubmitLoading(false);
  //     });
  // };

  useEffect(() => {
    setData((prev) => ({
      ...prev,
      cost_sheet_delete: deletedArrayList,
    }));
  }, [deletedArrayList]);

  return (
    <div>
      {!costSheetDataLoading && JobEnquiryInputValue ? (
        <>
          <div className="flex flex-col w-full gap-1 my-5 overflow-x-scroll pl-16">
            {quotationDetails?.type === "Cost Plus" ? (
              <>{/* <CostPlusCreate selectDatas={selectDatas} /> */}</>
            ) : (
              <div className="pb-5">
                {allRows.map((row, index) => (
                  <div key={row.id} className="flex gap-1 mt-1">
                    {row.sections.map((section, sectionIndex) => (
                      <div
                        className="flex flex-col relative"
                        key={section.rate_category_id}
                      >
                        {index == 0 && (
                          <>
                            {/* <div className="flex gap-1 absolute -top-8 right-0">
                              <button
                                type="button"
                                className=" p-1 rounded-md ring-1 ring-slate-300"
                                onClick={() =>
                                  handleCreateColumn(section.rate_category_id)
                                }
                              >
                                <BiPlus size={"1.2rem"} />
                              </button>
                            </div> */}
                            {/* <div
                              className={`w-full text-white py-2  ${tableHeading[sectionIndex].bgPrimary}`}
                            >
                              <h2 className="text-center">
                                {tableHeading[sectionIndex].title}
                              </h2>
                            </div> */}
                            <div className={`flex w-full gap-1 `}>
                              {section.rate_category_id == 1 && (
                                <>
                                  <h3
                                    className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                                  >
                                    SL. NO.
                                  </h3>
                                  <h3
                                    className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                                  >
                                    ACTUAL PROFESSION
                                  </h3>
                                  <h3
                                    className={`flex justify-center items-center text-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                                  >
                                    VISA PROFESSION
                                  </h3>
                                  <h3
                                    className={`flex justify-center items-center text-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                                  >
                                    PROFESSION LEVEL
                                  </h3>
                                  <h3
                                    className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                                  >
                                    GENDER
                                  </h3>
                                  <h3
                                    className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                                  >
                                    NATIONALITY
                                  </h3>
                                  <h3
                                    className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                                  >
                                    QUANTITY
                                  </h3>
                                </>
                              )}
                              {section.columns.map((column) => (
                                <div
                                  key={column.id}
                                  className={`${tableHeading[sectionIndex].bgSecondary}  ${tableProperties.colWidth} ${tableProperties.itemHeight} flex justify-center items-center relative`}
                                >
                                  {/* {!column.default && (
                                    <button
                                      type="button"
                                      className="bg-red text-white p-1 rounded-md ring-1 ring-red absolute -top-[2rem] right-8"
                                      onClick={() =>
                                        handleDeleteColumn(
                                          section.rate_category_id,
                                          column.id
                                        )
                                      }
                                    >
                                      <MdDeleteOutline size={"1.2rem"} />
                                    </button>
                                  )} */}
                                  {column.default ? (
                                    <h3 className="text-center text-sm">
                                      {column.title}
                                    </h3>
                                  ) : (
                                    <input
                                      type="text"
                                      className={`input input-sm  rounded-none focus:outline-none ${tableHeading[sectionIndex].bgSecondary}  ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                                      placeholder="Enter Title"
                                      required
                                      onChange={(e) =>
                                        handleUpdateColumn(
                                          row.id,
                                          column.rate_category_id,
                                          column.id,
                                          "rate_category_item_name",
                                          e.target.value?.toUpperCase(),
                                          column.rate_category_item_name
                                        )
                                      }
                                    />
                                  )}
                                </div>
                              ))}
                              {/* <div
                                className={`${tableHeading[sectionIndex].bgSecondary}  ${tableProperties.colWidth} ${tableProperties.itemHeight} flex justify-center items-center relative`}
                              >
                                {section.rate_category_id == 1 && (
                                  <h3 className="text-center text-sm">
                                    Total Emp. Salary Package
                                  </h3>
                                )}
                                {section.rate_category_id == 2 && (
                                  <h3 className="text-center text-sm">
                                    Total Gov. Fees
                                  </h3>
                                )}
                                {section.rate_category_id == 3 && (
                                  <h3 className="text-center text-sm">
                                    Total Soundline Fees
                                  </h3>
                                )}
                              </div> */}
                            </div>
                          </>
                        )}
                        <div className="flex w-full gap-1 relative">
                          {section.rate_category_id == 1 && (
                            <>
                              <div className="flex gap-1 absolute -left-16">
                                {allRows.length - 1 == index && (
                                  <button
                                    type="button"
                                    className=" p-1 rounded-md ring-1 ring-slate-300"
                                    onClick={handleCreateRow}
                                  >
                                    <BiPlus size={"1.2rem"} />
                                  </button>
                                )}
                              </div>
                              <button
                                type="button"
                                className="bg-red text-white p-1 rounded-md ring-1 ring-red absolute -left-8"
                                onClick={() => handleDeleteRow(row.id)}
                              >
                                <MdDeleteOutline size={"1.2rem"} />
                              </button>
                              <p
                                className={` bg-slate-200 flex items-center justify-center  ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                              >
                                {index + 1}
                              </p>

                              {/* ACTUAL PROFESSION / JOB POSITION  */}
                              <select
                                className={`bg-slate-200 select select-sm rounded-none focus:outline-none ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                                required
                                onChange={(e) =>
                                  handleUpdateRowProperties(
                                    row.id,
                                    "job_position_id",
                                    e.target.value
                                  )
                                }
                                defaultValue={row?.job_position_id}
                              >
                                <option value="" hidden>
                                  SELECT AN OPTION
                                </option>
                                {costSheetDefault.job_possition?.map(
                                  (optionData) => (
                                    <option
                                      value={optionData.id}
                                      key={optionData.id}
                                    >
                                      {optionData.name}
                                    </option>
                                  )
                                )}
                              </select>

                              {/* VISA PROFESSION */}
                              <select
                                className={`bg-slate-200 select select-sm rounded-none focus:outline-none ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                                required
                                onChange={(e) =>
                                  handleUpdateRowProperties(
                                    row.id,
                                    "visa_profession_id",
                                    e.target.value
                                  )
                                }
                                defaultValue={row?.visa_profession_id}
                              >
                                <option value="" hidden>
                                  SELECT AN OPTION
                                </option>
                                {costSheetDefault.visa_profession?.map(
                                  (optionData) => (
                                    <option
                                      value={optionData.id}
                                      key={optionData.id}
                                    >
                                      {optionData.name}
                                    </option>
                                  )
                                )}
                              </select>

                              {/* PROFESSION LEVEL */}
                              <select
                                className={`bg-slate-200 select select-sm rounded-none focus:outline-none ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                                required
                                onChange={(e) =>
                                  handleUpdateRowProperties(
                                    row.id,
                                    "profession_level_id",
                                    e.target.value
                                  )
                                }
                                defaultValue={row?.profession_level_id}
                              >
                                <option value="" hidden>
                                  SELECT AN OPTION
                                </option>
                                {costSheetDefault.profession_level?.map(
                                  (optionData) => (
                                    <option
                                      value={optionData.id}
                                      key={optionData.id}
                                    >
                                      {optionData.name}
                                    </option>
                                  )
                                )}
                              </select>

                              {/* GENDER */}
                              <select
                                className={`bg-slate-200 select select-sm rounded-none focus:outline-none ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                                required
                                onChange={(e) =>
                                  handleUpdateRowProperties(
                                    row.id,
                                    "gender",
                                    e.target.value
                                  )
                                }
                                defaultValue={row?.gender}
                              >
                                <option value="" hidden>
                                  SELECT AN OPTION
                                </option>
                                <option value="FEMALE">FEMALE</option>
                                <option value="MALE">MALE</option>
                              </select>

                              {/* NATIONALITY */}
                              <select
                                className={`bg-slate-200 select select-sm rounded-none focus:outline-none ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                                required
                                onChange={(e) =>
                                  handleUpdateRowProperties(
                                    row.id,
                                    "nationality_id",
                                    e.target.value
                                  )
                                }
                                defaultValue={row?.nationality_id}
                              >
                                <option value="" hidden>
                                  SELECT AN OPTION
                                </option>
                                {costSheetDefault.nationality?.map(
                                  (optionData) => (
                                    <option
                                      value={optionData.id}
                                      key={optionData.id}
                                    >
                                      {optionData.name}
                                    </option>
                                  )
                                )}
                              </select>

                              {/* QUANTITY */}
                              <input
                                type="text"
                                min={0}
                                className={`bg-slate-200 input input-sm rounded-none focus:outline-none ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                                required
                                placeholder="ENTER QUANTITY"
                                onChange={(e) =>
                                  handleUpdateRowProperties(
                                    row.id,
                                    "quantity",
                                    e.target.value?.toUpperCase()
                                  )
                                }
                                defaultValue={row?.quantity}
                              />
                            </>
                          )}
                          {section.columns.map((column) => (
                            <React.Fragment key={`${row.id}-${column.id}`}>
                              {column?.inputType == "text" ? (
                                <input
                                  type="text"
                                  className={`input input-sm rounded-none bg-slate-200 focus:outline-none ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                                  placeholder={
                                    column?.placeholder || "Enter value"
                                  }
                                  value={column.cost}
                                  required
                                  disabled={column?.disabled}
                                  onChange={(e) =>
                                    handleUpdateColumn(
                                      row.id,
                                      column.rate_category_id,
                                      column.id,
                                      "cost",
                                      e.target.value,
                                      column.rate_category_item_name
                                    )
                                  }
                                />
                              ) : (
                                <input
                                  type="number"
                                  min={0}
                                  step={"0.0001"}
                                  className={`input input-sm rounded-none bg-slate-200 focus:outline-none ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                                  placeholder="Enter Cost"
                                  value={column.cost}
                                  required
                                  disabled={column?.disabled}
                                  onChange={(e) =>
                                    handleUpdateColumn(
                                      row.id,
                                      column.rate_category_id,
                                      column.id,
                                      "cost",
                                      parseFloat(e.target.value),
                                      column.rate_category_item_name
                                    )
                                  }
                                />
                              )}
                            </React.Fragment>
                          ))}
                          {/* <input
                            type="text"
                            className={`input input-sm rounded-none bg-slate-200 focus:outline-none ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                            placeholder="Total"
                            disabled={true}
                            value={Number(
                              section.columns.reduce(
                                (accumulator, currentObject) =>
                                  accumulator +
                                  Number(currentObject?.cost || 0),
                                0
                              )
                            ).toFixed(2)}
                          /> */}
                        </div>
                      </div>
                    ))}
                    {/* <div className="flex flex-col relative">
                      {index === 0 && (
                        <>
                          <div className={`w-full text-white bg-zinc-800 py-2`}>
                            <h2 className="text-center">Total</h2>
                          </div>
                          <div className={`flex w-full gap-1 `}>
                            <div
                              className={`${tableProperties.colWidth} ${tableProperties.itemHeight} flex justify-center items-center relative bg-zinc-300`}
                            >
                              <h3 className="text-center text-sm">
                                Total Monthly Per Head Cost
                              </h3>
                            </div>
                          </div>
                        </>
                      )}
                      <div className="flex w-full gap-1 relative">
                        <input
                          type="text"
                          className={`input input-sm rounded-none bg-slate-200 focus:outline-none ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                          placeholder="Total"
                          disabled={true}
                          value={Number(
                            row.sections.reduce(
                              (accumulator, currentObject) => {
                                const sectionSum = currentObject.columns.reduce(
                                  (colAccumulator, column) =>
                                    colAccumulator + Number(column?.cost || 0),
                                  0
                                );
                                return accumulator + Number(sectionSum);
                              },
                              0
                            )
                          ).toFixed(2)}
                        />
                      </div>
                    </div> */}
                  </div>
                ))}
                {/* <button
                  className="bg-red rounded-md p-2 px-4 w-full max-w-xs text-white absolute left-1/2 mt-20 cursor-pointer text-sm"
                  type="submit"
                  disabled={submitLoading}
                >
                  {submitLoading ? (
                    <LoadingWithLable className={"!mt-0 text-white "} />
                  ) : (
                    `SUBMIT`
                  )}
                </button> */}
              </div>
            )}
          </div>
        </>
      ) : (
        <LoadingWithLable />
      )}
    </div>
  );
}
